/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const VideoEditorPublishedPlatformEntryDtoPlatformEnum = {
    YOUTUBE: "YOUTUBE",
    TWITTER: "TWITTER",
    INSTAGRAM: "INSTAGRAM",
    DAILYMOTION: "DAILYMOTION",
    FACEBOOK: "FACEBOOK",
    DEMO: "DEMO",
    TIKTOK: "TIKTOK"
} as const;

export type VideoEditorPublishedPlatformEntryDtoPlatformEnumKey = (typeof VideoEditorPublishedPlatformEntryDtoPlatformEnum)[keyof typeof VideoEditorPublishedPlatformEntryDtoPlatformEnum];

export const VideoEditorPublishedPlatformEntryDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type VideoEditorPublishedPlatformEntryDtoStatusEnumKey = (typeof VideoEditorPublishedPlatformEntryDtoStatusEnum)[keyof typeof VideoEditorPublishedPlatformEntryDtoStatusEnum];

export type VideoEditorPublishedPlatformEntryDto = {
    /**
     * @description Social platform (e.g. YOUTUBE, TWITTER)
     * @type string
    */
    platform: VideoEditorPublishedPlatformEntryDtoPlatformEnumKey;
    /**
     * @description Social upload job status (scheduled through terminal states)
     * @type string
    */
    status: VideoEditorPublishedPlatformEntryDtoStatusEnumKey;
    /**
     * @description Upload entity id from social-export
     * @type string, uuid
    */
    uploadId: string;
};